import { apiRequest } from "@/lib/api";

export interface AdminDianProcess {
  processId: string;
  companyNit: string;
  documentType: string;
  sourceDocumentId: string | null;
  status: string;
  errorJson: unknown;
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedAdminDianProcesses {
  processes: AdminDianProcess[];
  pagination: { total: number; page: number; pageSize: number; pageCount: number };
}

export interface ListAllProcessesParams {
  companyId?: string;
  status?: string;
  documentType?: string;
  periodFrom?: string;
  periodTo?: string;
  page?: number;
  pageSize?: number;
}

export function listAllProcesses(
  params: ListAllProcessesParams,
): Promise<PaginatedAdminDianProcesses> {
  return apiRequest("/api/admin/dian-processes", {
    query: params as Record<string, unknown>,
  });
}